<template>
    <div class="waba-error-codes">
        <div class="search-container">
            <a-input v-model="searchQuery" :placeholder="$t('message.wabaErrorSearchPlaceholder')" :allowClear="true">
                <a-icon slot="prefix" type="search" />
            </a-input>
        </div>
        <a-collapse v-model="activeKey" accordion>
            <a-collapse-panel v-for="(error, index) in filteredErrors" :key="index" :header="error.originalError">
                <div class="error-description">
                    <div class="description-tr">
                        <strong>{{ $t("message.wabaErrorLabelTr") }}</strong>
                        <p>{{ error.descriptions.tr }}</p>
                    </div>
                    <div class="description-en">
                        <strong>{{ $t("message.wabaErrorLabelEn") }}</strong>
                        <p>{{ error.descriptions.en }}</p>
                    </div>
                    <a-alert class="meta-link-alert" type="info" show-icon>
                        <template #message>
                            <span>
                                {{ $t("message.wabaErrorMoreDetailPrefix") }}
                                <a
                                    href="https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {{ $t("message.wabaErrorVisitMetaDocs") }}
                                </a>
                            </span>
                        </template>
                    </a-alert>
                </div>
            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script>
export default {
    name: "WABAErrorCodes",
    props: {
        defaultSelectedError: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            searchQuery: "",
            activeKey: null,
            wabaErrors: [
                {
                    originalError:
                        "OAuthException, (#132015) Template is temporarily unavailable to use because it was paused due to low quality.",
                    descriptions: {
                        tr: "Bu hata, şablonun düşük kalite nedeniyle geçici olarak devre dışı bırakıldığını belirtir. Genellikle kullanıcılar tarafından düşük puanlanma veya sık sık reddedilme nedeniyle oluşur. Çözüm için şablonun içeriğini gözden geçirin ve daha kaliteli hale getirin.",
                        en: "This error indicates that the template has been temporarily disabled due to low quality. It usually occurs due to low user ratings or frequent rejections. Review the template content and improve its quality to resolve this.",
                    },
                },
                {
                    originalError: "OAuthException, (#132005) Translated text too long",
                    descriptions: {
                        tr: "Çevirilen metnin çok uzun olduğunu belirtir. Mesaj uzunluğunu azaltarak daha kısa ve öz bir metin oluşturun.",
                        en: "Indicates that the translated text is too long. Shorten the message to make it concise and within limits.",
                    },
                },
                {
                    originalError: "OAuthException, (#131008) Required parameter is missing",
                    descriptions: {
                        tr: "Gerekli bir parametrenin eksik olduğunu gösterir. API dokümantasyonunu kontrol ederek eksik parametreleri tamamlayın.",
                        en: "Indicates that a required parameter is missing. Check the API documentation and include the missing parameters.",
                    },
                },
                {
                    originalError: "OAuthException, (#100) The parameter text['body'] is required.",
                    descriptions: {
                        tr: "'text[\"body\"]' parametresi zorunludur. Mesaj metnini eklediğinizden emin olun.",
                        en: "The 'text[\"body\"]' parameter is required. Ensure you include the message text.",
                    },
                },
                {
                    originalError: "Spam Rate limit hit",
                    descriptions: {
                        tr: "Mesaj gönderim sıklığınız sınırı aştı. Gönderim oranınızı azaltın.",
                        en: "Your message sending frequency exceeded the limit. Reduce your sending rate.",
                    },
                },
                {
                    originalError:
                        "GraphMethodException, Unsupported post request. Object with ID '314167035111669' does not exist, cannot be loaded due to missing permissions, or does not support this operation.",
                    descriptions: {
                        tr: "Belirtilen ID mevcut değil veya gerekli izinler eksik. ID ve izinleri kontrol edin.",
                        en: "The specified ID does not exist or the required permissions are missing. Check the ID and permissions.",
                    },
                },
                {
                    originalError: "Message undeliverable",
                    descriptions: {
                        tr: "Mesaj alıcıya teslim edilemedi. Alıcı geçersiz bir whatsapp numarası olabilir veya alıcı whatsapp gizlilik sözleşmesini kabul etmemiş olabilir.",
                        en: "The message could not be delivered to the recipient. The recipient may have an invalid WhatsApp number or may not have accepted the WhatsApp privacy policy.",
                    },
                },
                {
                    originalError: "OAuthException, (#100) Invalid parameter",
                    descriptions: {
                        tr: "Geçersiz bir parametre gönderildi. Parametre formatını kontrol edin.",
                        en: "An invalid parameter was sent. Check the parameter format.",
                    },
                },
                {
                    originalError: "User's number is part of an experiment",
                    descriptions: {
                        tr: "Alıcı numarası bir deneyin parçası. Mesaj gönderimini bir süre sonra yeniden deneyin.",
                        en: "The recipient's number is part of an experiment. Try sending the message again later.",
                    },
                },
                {
                    originalError: "OAuthException, (#131053) Media upload error",
                    descriptions: {
                        tr: "Medya yükleme sırasında bir hata oluştu. Medya formatını ve boyutunu doğrulayın.",
                        en: "A media upload error occurred. Validate the media format and size.",
                    },
                },
                {
                    originalError: "OAuthException, (#2) Service temporarily unavailable",
                    descriptions: {
                        tr: "Hizmet geçici olarak kullanılamıyor. Daha sonra tekrar deneyin.",
                        en: "The service is temporarily unavailable. Please try again later.",
                    },
                },
                {
                    originalError: "OAuthException, (#200) You do not have permission to access this field.",
                    descriptions: {
                        tr: "Bu alana erişim izniniz yok. Gerekli izinlerin verildiğinden emin olun.",
                        en: "You do not have permission to access this field. Ensure the required permissions are granted.",
                    },
                },
                {
                    originalError: "Business Account locked",
                    descriptions: {
                        tr: "İşletme hesabınız kilitlenmiş. Hesabınızı tekrar etkinleştirmek için destek ekibiyle iletişime geçin.",
                        en: "Your business account is locked. Contact support to reactivate your account.",
                    },
                },
                {
                    originalError: "This message was not delivered to maintain healthy ecosystem engagement.",
                    descriptions: {
                        tr: "Mesaj sağlıklı bir ekosistem için teslim edilmedi. Mesaj içeriğinizi ve sıklığınızı gözden geçirin. Alıcıya belli bir zaman aralığında bir kaç tane marketing template atabilirsiniz daha fazlasına izin verilmez.",
                        en: "The message was not delivered to maintain a healthy ecosystem. Review your message content and frequency. You can send a few marketing templates to the recipient within a certain time interval, but more than that is not allowed.",
                    },
                },
                {
                    originalError: "Re-engagement message",
                    descriptions: {
                        tr: "Alıcıyla yeniden etkileşim mesajı gönderilemedi. Alıcının katılım onayını doğrulayın.",
                        en: "The re-engagement message could not be sent. Verify the recipient's opt-in status.",
                    },
                },
                {
                    originalError: "OAuthException, (#135000) Generic user error",
                    descriptions: {
                        tr: "Genel bir kullanıcı hatası oluştu. API isteğinizi kontrol edin.",
                        en: "A generic user error occurred. Check your API request.",
                    },
                },
                {
                    originalError: "Business eligibility payment issue",
                    descriptions: {
                        tr: "İşletme uygunluk ödemesiyle ilgili bir sorun var. Fatura ve ödeme ayarlarını kontrol edin.",
                        en: "There is an issue with business eligibility payment. Check your billing and payment settings.",
                    },
                },
                {
                    originalError: "Generic user error",
                    descriptions: {
                        tr: "Genel bir kullanıcı hatası oluştu. Detaylı bilgi için hata kodlarını kontrol edin.",
                        en: "A generic user error occurred. Check error codes for more details.",
                    },
                },
                {
                    originalError:
                        "OAuthException, (#131037) WhatsApp provided number needs display name approval before message can be sent.",
                    descriptions: {
                        tr: "WhatsApp numarası için görüntüleme adı onayı gerekiyor. Onay işlemini tamamlayın.",
                        en: "The WhatsApp number requires display name approval before messages can be sent. Complete the approval process.",
                    },
                },
                {
                    originalError:
                        "OAuthException, (#132000) Number of parameters does not match the expected number of params",
                    descriptions: {
                        tr: "Gönderilen parametre sayısı beklenenle eşleşmiyor. Parametrelerinizi doğrulayın.",
                        en: "The number of parameters does not match the expected count. Verify your parameters.",
                    },
                },
                // Yeni eklenen hata kodları (MD listesinden)
                {
                    originalError: "(#0) AuthException",
                    descriptions: {
                        tr: "Uygulama kullanıcısı kimlik doğrulaması yapılamadı. Access token süresi dolmuş, geçersiz kılınmış veya kullanıcı ayarları değiştirilmiş olabilir. Yeni bir access token alın.",
                        en: "We were unable to authenticate the app user. The access token may have expired, been invalidated, or the user changed settings. Get a new access token.",
                    },
                },
                {
                    originalError: "(#1) API Unknown",
                    descriptions: {
                        tr: "Geçersiz istek veya olası sunucu hatası. WhatsApp Business Platform durum sayfasını kontrol edin. Sunucu sorunu yoksa endpoint referansını ve istek formatını doğrulayın.",
                        en: "Invalid request or possible server error. Check WhatsApp Business Platform Status. Verify endpoint reference and request format.",
                    },
                },
                {
                    originalError: "(#3) API Method",
                    descriptions: {
                        tr: "Yetenek veya izin sorunu. Access token debugger ile uygulamanızın gerekli izinlere sahip olduğunu doğrulayın.",
                        en: "Capability or permissions issue. Use access token debugger to verify your app has the required permissions.",
                    },
                },
                {
                    originalError: "(#4) API Too Many Calls",
                    descriptions: {
                        tr: "Uygulama API çağrı hız limitine ulaştı. App Dashboard'dan rate limit durumunu kontrol edin. Daha sonra tekrar deneyin veya API sorgu sıklığını azaltın.",
                        en: "The app has reached its API call rate limit. Check Application Rate Limit in App Dashboard. Try again later or reduce API query frequency.",
                    },
                },
                {
                    originalError: "(#10) Permission Denied",
                    descriptions: {
                        tr: "İzin verilmemiş veya kaldırılmış. Access token debugger ile gerekli izinlerin verildiğini doğrulayın.",
                        en: "Permission is either not granted or has been removed. Use access token debugger to verify required permissions are granted.",
                    },
                },
                {
                    originalError: "(#33) Parameter value is not valid",
                    descriptions: {
                        tr: "İşletme telefon numarası silinmiş olabilir. Numaranın doğru olduğunu doğrulayın.",
                        en: "The business phone number may have been deleted. Verify the phone number is correct.",
                    },
                },
                {
                    originalError: "(#368) Temporarily blocked for policies violations",
                    descriptions: {
                        tr: "WhatsApp Business hesabı platform politikası ihlali nedeniyle kısıtlandı veya devre dışı bırakıldı. Policy Enforcement dokümanına bakın.",
                        en: "The WhatsApp Business Account has been restricted or disabled for violating a platform policy. See Policy Enforcement document.",
                    },
                },
                {
                    originalError: "(#190) Access token has expired",
                    descriptions: {
                        tr: "Access token süresi dolmuş. Yeni bir access token alın.",
                        en: "Your access token has expired. Get a new access token.",
                    },
                },
                {
                    originalError: "(#130429) Rate limit hit",
                    descriptions: {
                        tr: "Cloud API mesaj throughput limitine ulaşıldı. Throughput dokümanına bakın. Daha sonra tekrar deneyin veya mesaj gönderim sıklığını azaltın.",
                        en: "Cloud API message throughput has been reached. See Throughput. Try again later or reduce message frequency.",
                    },
                },
                {
                    originalError: "(#130497) Business account is restricted from messaging users in this country",
                    descriptions: {
                        tr: "WhatsApp Business hesabı belirli ülkelerdeki kullanıcılara mesaj göndermekten kısıtlı. WhatsApp Business Messaging Policy'ye bakın.",
                        en: "The WhatsApp Business Account is restricted from messaging users in certain countries. See WhatsApp Business Messaging Policy.",
                    },
                },
                {
                    originalError: "(#80007) Rate limit issues",
                    descriptions: {
                        tr: "WhatsApp Business hesabı rate limit'e ulaştı. Rate Limits dokümanına bakın. Daha sonra tekrar deneyin veya mesaj gönderim sıklığını azaltın.",
                        en: "The WhatsApp Business Account has reached its rate limit. See Rate Limits. Try again later or reduce message frequency.",
                    },
                },
                {
                    originalError: "(#131000) Something went wrong",
                    descriptions: {
                        tr: "Bilinmeyen bir hata nedeniyle mesaj gönderilemedi. Tekrar deneyin. Sorun devam ederse Direct Support bileti açın.",
                        en: "Message failed to send due to unknown error. Try again. If persists, open a Direct Support ticket.",
                    },
                },
                {
                    originalError: "(#131005) Access denied",
                    descriptions: {
                        tr: "İzin verilmemiş veya kaldırılmış. Access token debugger ile gerekli izinlerin verildiğini doğrulayın.",
                        en: "Permission is either not granted or has been removed. Use access token debugger to verify required permissions.",
                    },
                },
                {
                    originalError: "(#131009) Parameter value is not valid",
                    descriptions: {
                        tr: "Bir veya daha fazla parametre değeri geçersiz. Endpoint referansından desteklenen değerleri kontrol edin.",
                        en: "One or more parameter values are invalid. Check endpoint reference for supported values.",
                    },
                },
                {
                    originalError: "(#131016) Service unavailable",
                    descriptions: {
                        tr: "Hizmet geçici olarak kullanılamıyor. WhatsApp Business Platform durum sayfasını kontrol edip tekrar deneyin.",
                        en: "A service is temporarily unavailable. Check WhatsApp Business Platform Status and try again.",
                    },
                },
                {
                    originalError: "(#131021) Recipient cannot be sender",
                    descriptions: {
                        tr: "Gönderen ve alıcı telefon numarası aynı. Farklı bir numaraya mesaj gönderin.",
                        en: "Sender and recipient phone number is the same. Send message to a different phone number.",
                    },
                },
                {
                    originalError: "(#131045) Incorrect certificate",
                    descriptions: {
                        tr: "Telefon numarası kayıt hatası nedeniyle mesaj gönderilemedi. Numaranızı kaydetmeden önce tekrar deneyin.",
                        en: "Message failed due to phone number registration error. Register the phone number before trying again.",
                    },
                },
                {
                    originalError: "(#131050) User has stopped receipt of marketing messages",
                    descriptions: {
                        tr: "Bu alıcı sizin işletmenizden pazarlama mesajları almayı durdurmayı seçti. Bu kullanıcıya tekrar mesaj göndermeyi denemeyin. user_preferences webhook'una abone olun.",
                        en: "This recipient has chosen to stop receiving marketing messages. Do not retry. Subscribe to user_preferences webhook for notifications.",
                    },
                },
                {
                    originalError: "(#131051) Unsupported message type",
                    descriptions: {
                        tr: "Desteklenmeyen mesaj türü. Messages dokümanından desteklenen mesaj türlerini kontrol edin.",
                        en: "Unsupported message type. See Messages for supported message types.",
                    },
                },
                {
                    originalError: "(#131052) Media download error",
                    descriptions: {
                        tr: "Kullanıcının gönderdiği medya indirilemedi. Kullanıcıdan medyayı WhatsApp dışı bir yöntemle göndermesini isteyin.",
                        en: "Unable to download media from user's message. Ask user to send media using non-WhatsApp method.",
                    },
                },
                {
                    originalError: "(#131055) Method not allowed",
                    descriptions: {
                        tr: "Template olmayan veya authentication/utility template gönderilmeye çalışıldı. Marketing template mesajı kullanarak tekrar gönderin.",
                        en: "Non-template or authentication/utility template was attempted. Try again using marketing template message.",
                    },
                },
                {
                    originalError: "(#131056) (Business Account, Consumer Account) pair rate limit hit",
                    descriptions: {
                        tr: "Gönderen numarasından aynı alıcıya kısa sürede çok fazla mesaj gönderildi. Aynı numaraya mesaj göndermek için bekleyip tekrar deneyin.",
                        en: "Too many messages sent from sender to same recipient in short period. Wait and retry for same number, or send to different number.",
                    },
                },
                {
                    originalError: "(#131057) Account in maintenance mode",
                    descriptions: {
                        tr: "WhatsApp Business hesabı bakım modunda. Hesap throughput yükseltmesi yapılıyor olabilir.",
                        en: "The WhatsApp Business Account is in maintenance mode. Account may be undergoing throughput upgrade.",
                    },
                },
                {
                    originalError: "(#132001) Template does not exist",
                    descriptions: {
                        tr: "Şablon belirtilen dilde mevcut değil veya onaylanmamış. Şablon adı ve dil kodunu kontrol edin.",
                        en: "Template does not exist in specified language or has not been approved. Verify template name and language locale.",
                    },
                },
                {
                    originalError: "(#132007) Template Format Character Policy Violated",
                    descriptions: {
                        tr: "Şablon içeriği WhatsApp politikasını ihlal ediyor. Template review dokümanına bakın.",
                        en: "Template content violates WhatsApp policy. See Template review document.",
                    },
                },
                {
                    originalError: "(#132012) Template Parameter Format Mismatch",
                    descriptions: {
                        tr: "Değişken parametre değerleri yanlış formatta. Şablonda belirtilen formata uygun değerler gönderin.",
                        en: "Variable parameter values are incorrectly formatted. Use format specified in template.",
                    },
                },
                {
                    originalError: "(#132016) Template is Disabled",
                    descriptions: {
                        tr: "Şablon düşük kalite nedeniyle çok kez duraklatıldı ve kalıcı olarak devre dışı bırakıldı. Farklı içerikle yeni şablon oluşturun.",
                        en: "Template has been paused too many times and is now permanently disabled. Create new template with different content.",
                    },
                },
                {
                    originalError: "(#132018) Template validation error",
                    descriptions: {
                        tr: "Şablondaki parametrelerde sorun var. Hataları inceleyip parametreleri güncelleyin ve doğru yapılandırılmış şablonla tekrar gönderin.",
                        en: "There's an issue with template parameters. Review errors, update parameters, and resend with correctly configured template.",
                    },
                },
                {
                    originalError: "(#132068) Flow is blocked",
                    descriptions: {
                        tr: "Flow engellenmiş durumda. Flow'u düzeltin.",
                        en: "Flow is in blocked state. Correct the Flow.",
                    },
                },
                {
                    originalError: "(#132069) Flow is throttled",
                    descriptions: {
                        tr: "Flow throttle durumunda ve son bir saatte bu flow ile 10 mesaj zaten gönderildi. Flow'u düzeltin.",
                        en: "Flow is throttled and 10 messages using this flow were already sent in last hour. Correct the Flow.",
                    },
                },
                {
                    originalError: "(#133000) Incomplete Deregistration",
                    descriptions: {
                        tr: "Önceki kayıt silme denemesi başarısız oldu. Numarayı tekrar kayıttan çıkarın, sonra yeniden kaydedin.",
                        en: "A previous deregistration attempt failed. Deregister the number again before registering.",
                    },
                },
                {
                    originalError: "(#133004) Server Temporarily Unavailable",
                    descriptions: {
                        tr: "Sunucu geçici olarak kullanılamıyor. WhatsApp Business Platform durum sayfasını kontrol edip tekrar deneyin.",
                        en: "Server is temporarily unavailable. Check WhatsApp Business Platform Status and try again.",
                    },
                },
                {
                    originalError: "(#133005) Two step verification PIN Mismatch",
                    descriptions: {
                        tr: "İki adımlı doğrulama PIN'i yanlış. İstekteki PIN'in doğru olduğunu doğrulayın. Sıfırlamak için iki adımlı doğrulamayı kapatıp yeni PIN belirleyin.",
                        en: "Two-step verification PIN incorrect. Verify PIN in request. To reset, disable two-step verification then set new PIN.",
                    },
                },
                {
                    originalError: "(#133006) Phone number re-verification needed",
                    descriptions: {
                        tr: "Kayıt öncesi telefon numarasının doğrulanması gerekiyor. Numarayı doğrulayıp kaydedin.",
                        en: "Phone number needs to be verified before registering. Verify and register the phone number.",
                    },
                },
                {
                    originalError: "(#133008) Too Many two step verification PIN Guesses",
                    descriptions: {
                        tr: "Bu numara için çok fazla iki adımlı doğrulama PIN denemesi yapıldı. details yanıt değerinde belirtilen süre kadar bekleyip tekrar deneyin.",
                        en: "Too many two-step verification PIN guesses. Try again after the time specified in details response.",
                    },
                },
                {
                    originalError: "(#133009) Two step verification PIN Guessed Too Fast",
                    descriptions: {
                        tr: "İki adımlı doğrulama PIN'i çok hızlı girildi. Tekrar denemeden önce details yanıt değerini kontrol edin.",
                        en: "Two-step verification PIN was entered too quickly. Check details response before trying again.",
                    },
                },
                {
                    originalError: "(#133010) Phone number Not Registered",
                    descriptions: {
                        tr: "Telefon numarası WhatsApp Business Platform'da kayıtlı değil. Önce numarayı kaydedin.",
                        en: "Phone number not registered on WhatsApp Business Platform. Register the phone number before trying again.",
                    },
                },
                {
                    originalError: "(#133015) Please wait a few minutes before attempting to register this phone number",
                    descriptions: {
                        tr: "Kaydetmeye çalıştığınız numara yakın zamanda silindi ve silme henüz tamamlanmadı. 5 dakika bekleyip tekrar deneyin.",
                        en: "The number was recently deleted and deletion has not completed. Wait 5 minutes before re-trying.",
                    },
                },
                {
                    originalError: "(#133016) Account register deregister rate limit exceeded",
                    descriptions: {
                        tr: "Bu numara için kısa sürede çok fazla kayıt/kayıt silme denemesi yapıldı. Numara bloke edildi. Açılana kadar bekleyip tekrar deneyin.",
                        en: "Too many registration/deregistration attempts for this phone number. The number is blocked. Try again once unblocked.",
                    },
                },
                {
                    originalError: "(#134011) WhatsApp Payments terms of service has not been accepted",
                    descriptions: {
                        tr: "Bu WABA için WhatsApp Payments hizmet şartları kabulü bekleniyor. Hata mesajındaki bağlantıyı kullanarak şartları kabul edin.",
                        en: "WhatsApp Payments terms of service acceptance is pending. Accept using the link in the error message.",
                    },
                },
                {
                    originalError: "(#134100) Only marketing messages supported",
                    descriptions: {
                        tr: "Utility veya authentication template gönderilmeye çalışıldı. Sadece MARKETING kategorisindeki şablonlar desteklenir.",
                        en: "You attempted to send utility or authentication template. Only templates categorized as MARKETING are supported.",
                    },
                },
                {
                    originalError: "(#134101) Your template is still syncing",
                    descriptions: {
                        tr: "Yeni oluşturulan şablon Ad senkronizasyonu tamamlanmadan gönderilmeye çalışıldı. Senkronizasyon 10 dakika sürebilir. 10 dakika bekleyip tekrar deneyin.",
                        en: "Attempted to send newly created template before Ad sync completed. Sync can take 10 minutes. Wait 10 minutes and try again.",
                    },
                },
                {
                    originalError: "(#134102) Template unavailable for use",
                    descriptions: {
                        tr: "Göndermeye çalıştığınız şablon için Ad senkronizasyonu tamamlanamadı veya MM API için uygun değilsiniz. Uygunluk durumunuzu kontrol edin.",
                        en: "Unable to complete Ad sync for template, or you may not be eligible for MM API. Check your eligibility status.",
                    },
                },
                {
                    originalError: "(#1752041) Duplicate Request",
                    descriptions: {
                        tr: "İş müşterisi zaten bir partner tarafından onboard edilmek üzere davet edilmiş. Onboarding isteği iş müşterisi başına bir ile sınırlıdır.",
                        en: "Client has already been invited to onboard by a partner. Onboarding requests are limited to one per business customer.",
                    },
                },
                // Template creation errors
                {
                    originalError: "(#2388040) Character limit exceeded",
                    descriptions: {
                        tr: "Şablondaki bir alan izin verilen maksimum karakter sınırını aştı. Hata mesajından etkilenen alanı ve karakter limitlerini kontrol edin.",
                        en: "A field in your template has exceeded the maximum character limit. Refer to the error message for the affected field and its character limits.",
                    },
                },
                {
                    originalError: "(#2388047) Message header format is incorrect",
                    descriptions: {
                        tr: "Mesaj başlığınız geçersiz biçimlendirme içeriyor. Hata mesajından geçerli biçimlendirme detaylarını kontrol edin.",
                        en: "Your message header contains invalid formatting. Refer to the error message for valid formatting details.",
                    },
                },
                {
                    originalError: "(#2388072) Message body format is incorrect",
                    descriptions: {
                        tr: "Mesaj gövdeniz geçersiz biçimlendirme içeriyor. Hata mesajından geçerli biçimlendirme detaylarını kontrol edin.",
                        en: "Your message body contains invalid formatting. Refer to the error message for valid formatting details.",
                    },
                },
                {
                    originalError: "(#2388073) Message footer format is incorrect",
                    descriptions: {
                        tr: "Mesaj alt bilginiz geçersiz biçimlendirme içeriyor. Hata mesajından geçerli biçimlendirme detaylarını kontrol edin.",
                        en: "Your message footer contains invalid formatting. Refer to the error message for valid formatting details.",
                    },
                },
                {
                    originalError: "(#2388293) Parameters words ratio exceeds limit",
                    descriptions: {
                        tr: "Bu şablonda uzunluğuna göre çok fazla değişken var. Değişken sayısını azaltın veya mesaj uzunluğunu artırın.",
                        en: "This template has too many variables for its length. Reduce the number of variables or increase the message length.",
                    },
                },
                {
                    originalError: "(#2388299) Leading or trailing parameters not allowed",
                    descriptions: {
                        tr: "Değişkenler şablonun başında veya sonunda olamaz. Hata mesajından geçerli biçimlendirme detaylarını kontrol edin.",
                        en: "Variables cannot be at the start or end of the template. Refer to the error message for valid formatting details.",
                    },
                },
                {
                    originalError: "(#2388019) Message Template Limit Exceeded",
                    descriptions: {
                        tr: "Bu WhatsApp işletme hesabı için sahip olabileceğiniz maksimum mesaj şablonu sayısını aştınız. Bir hesapta en fazla 250 şablon olabilir.",
                        en: "You have exceeded the maximum number of message templates (250) for this WhatsApp business account. See Template limits.",
                    },
                },
                // Phone migration errors
                {
                    originalError: "(#2388001) Please confirm ownership of this phone number",
                    descriptions: {
                        tr: "Sertifika yalnızca taşınmakta olan telefon numarasının sahipliği doğrulandıktan sonra indirilebilir. Numarayı kaydedip doğrulayın.",
                        en: "Certificate can be downloaded only after confirming ownership of the phone number being migrated. Register and verify the number.",
                    },
                },
                {
                    originalError: "(#2388001) Please ensure two-step authentication is disabled",
                    descriptions: {
                        tr: "Bu telefon numarası için iki adımlı doğrulama kapatılmalı. WhatsApp Business Manager Ayarları'nda iki adımlı doğrulamayı kapatın.",
                        en: "Two-step authentication must be disabled for this phone number. Turn off two-step verification in WhatsApp Business Manager Settings.",
                    },
                },
                {
                    originalError: "(#2388012) This phone number already exists in your list of phone numbers",
                    descriptions: {
                        tr: "Taşımaya çalıştığınız numara zaten WhatsApp hesabınızda mevcut. Hesabınızda olmayan bir numara ile tekrar deneyin.",
                        en: "The phone number you are trying to migrate is already present in your WhatsApp account. Try with a number not already in your account.",
                    },
                },
                {
                    originalError: "(#2388091) (#2388093) This phone number isn't eligible to receive/verify a registration code",
                    descriptions: {
                        tr: "Bu numara taşınmadığı için kayıt kodu alma/doğrulama için uygun değil. Numarayı kaydedip doğrulayın.",
                        en: "Phone ownership verification APIs are not available for this use case. Register and verify the number.",
                    },
                },
                {
                    originalError: "(#2388103) Cannot migrate phone number",
                    descriptions: {
                        tr: "Hedef WhatsApp Business hesabı için webhook'lar ayarlanmamış. Uygulamanızı hedef hesaptaki webhook'lara abone edin.",
                        en: "Webhooks have not been set up for the destination WhatsApp Business account. Subscribe your app to webhooks on the destination account.",
                    },
                },
                {
                    originalError: "(#2388103) Please add this phone number in your WhatsApp account",
                    descriptions: {
                        tr: "Bu numara doğrudan eklenmeye uygun, telefon taşıma API'lerini kullanmanıza gerek yok. Numarayı kaydedip doğrulayın.",
                        en: "This phone number is eligible to be added directly. Register and verify the number.",
                    },
                },
                {
                    originalError: "(#2388103) Registered name should be present and approved",
                    descriptions: {
                        tr: "İşletme telefon numarasının onaylanmış display name'e (name_status: APPROVED) ihtiyacı var. Display name'i onaylatın.",
                        en: "The business phone number must have an approved display name. Get your display name approved.",
                    },
                },
                {
                    originalError: "(#2388103) The WhatsApp account that this phone number is registered with is not set up correctly",
                    descriptions: {
                        tr: "Kaynak WABA onaylı olmalı ve 'messaging on behalf of' onaylı olmalı. Destekle iletişime geçin.",
                        en: "The source WhatsApp Business Account must be approved and its messaging on behalf of must be approved. Contact support.",
                    },
                },
                {
                    originalError: "(#2388103) Your WhatsApp account does not have a payment account",
                    descriptions: {
                        tr: "Taşımadan sonra mesaj göndermek için WhatsApp hesabınızda aktif kredi limiti olmalı. Kredi limiti kurun.",
                        en: "Your WhatsApp account must have an active credit line to send messages after migration. Set up a credit line.",
                    },
                },
                {
                    originalError: "(#2388103) There was an error migrating this phone number",
                    descriptions: {
                        tr: "Telefon numaranızı taşırken bir hata oluştu. Bir süre sonra tekrar deneyin. Çalışmazsa destekle iletişime geçin.",
                        en: "Something went wrong when trying to migrate your phone number. Try again later. Contact support if it doesn't work.",
                    },
                },
                {
                    originalError: "(#2388103) This phone number belongs to a different Business Manager account",
                    descriptions: {
                        tr: "Kaynak ve hedef WABA'lar aynı işletmeyi temsil etmeli. Numarayı aynı işletme adına mesaj gönderen bir WABA'ya taşıyın.",
                        en: "The source and destination WABAs must represent the same business. Migrate to a WABA messaging for the same business.",
                    },
                },
                {
                    originalError: "(#2388103) Your WhatsApp account must be approved",
                    descriptions: {
                        tr: "Numara taşımadan önce hedef WhatsApp Business hesabı onaylanmış olmalı. İşletme doğrulamasını tamamlayın.",
                        en: "The destination WhatsApp Business Account must be approved before migrating. Ensure business verification is completed.",
                    },
                },
                {
                    originalError: "(#2388103) Your WhatsApp account's Messaging For request must be approved",
                    descriptions: {
                        tr: "Hedef WABA 'Messaging For' talebi müşteri tarafından onaylanmalı. Müşterinizden Meta Business Suite'te talebi kabul etmesini isteyin.",
                        en: "The destination WABA Messaging For request must be approved by the client. Ask your client to accept the request in Meta Business Suite.",
                    },
                },
                {
                    originalError: "(#2494100) Account is in maintenance mode",
                    descriptions: {
                        tr: "İşletme telefon numarası bakım modunda. Birkaç dakika sonra tekrar deneyin.",
                        en: "The business phone number is in maintenance mode. Try again in a few minutes.",
                    },
                },
                // Template insights errors
                {
                    originalError: "(#200005) Template insights unavailable",
                    descriptions: {
                        tr: "Bu WhatsApp Business hesabı için şablon içgörüleri henüz mevcut değil. Şu anda şablon içgörülerini etkinleştiremezsiniz.",
                        en: "Template insights are not available yet for this WhatsApp Business account. You are unable to enable template insights at the moment.",
                    },
                },
                {
                    originalError: "(#200006) Cannot disable template insights",
                    descriptions: {
                        tr: "Geçersiz işlem. Template Insights bir kez etkinleştirildikten sonra devre dışı bırakılamaz.",
                        en: "Invalid operation. Template Insights cannot be disabled once enabled for a WhatsApp Business account.",
                    },
                },
                {
                    originalError: "(#200007) Template Insights not enabled",
                    descriptions: {
                        tr: "Template Insights bu WhatsApp Business hesabı için etkinleştirilmemiş. Etkinleştirmek için template analytics dokümanına bakın.",
                        en: "Template Insights have not been enabled for this WhatsApp Business Account. See Confirming template analytics to enable.",
                    },
                },
                // WABA errors
                {
                    originalError: "(#2593079) Template insights unavailable - WABA marked for migration",
                    descriptions: {
                        tr: "Bu WABA zaten farklı bir solution ID'ye taşınmak üzere işaretlenmiş. OBO modeli artık deprecated. Destekle iletişime geçin.",
                        en: "This WABA has already been marked for migration to a different solution ID. OBO model is deprecated. Please contact support.",
                    },
                },
                {
                    originalError: "(#2593085) Invalid WhatsApp Business Account for OBO Mobility",
                    descriptions: {
                        tr: "WABA OBO sahiplik transferi için uygun değil. WABA zaten müşteriye ait olabilir veya müşteri Meta Business Suite'te OBO talebini henüz kabul etmemiş olabilir. Destekle iletişime geçin.",
                        en: "The WABA is not eligible for OBO ownership transfer. WABA may already be owned by the customer or customer has yet to accept the OBO request. Contact support.",
                    },
                },
                // Synchronization errors
                {
                    originalError: "(#2593107) Synchronization Request limit exceeded",
                    descriptions: {
                        tr: "Bu telefon numarası için senkronizasyon API'sini çağırma sayısı limitini aştınız. Müşteriyi offboard edip yeniden onboard edin.",
                        en: "You have exceeded the maximum number of times to call the synchronization API for this phone number. Offboard the business customer and re-onboard them.",
                    },
                },
                {
                    originalError: "(#2593108) Synchronization Request made outside of allowed time window",
                    descriptions: {
                        tr: "Senkronizasyon talebi yalnızca onboard işleminden 24 saat içinde yapılabilir. Kullanıcıyı offboard edip yeniden onboard edin.",
                        en: "Synchronization can only be initiated within 24 hours of onboarding. Offboard the user and re-onboard them.",
                    },
                },
            ],
        };
    },
    computed: {
        filteredErrors() {
            if (!this.searchQuery) return this.wabaErrors;

            const query = this.searchQuery.toLowerCase();
            return this.wabaErrors.filter(
                (error) =>
                    error.originalError.toLowerCase().includes(query) ||
                    error.descriptions.tr.toLowerCase().includes(query) ||
                    error.descriptions.en.toLowerCase().includes(query)
            );
        },
    },
    created() {
        if (this.defaultSelectedError) {
            const index = this.wabaErrors.findIndex(error => {
                return error.originalError.trim().toLowerCase() === this.defaultSelectedError.trim().toLowerCase();
            });
            if (index !== -1) {
                this.activeKey = index;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.waba-error-codes {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;

    .search-container {
        margin-bottom: 16px;

        :deep(.ant-input-affix-wrapper) {
            background-color: var(--color-bg-neutral-default);
            border: 1px solid var(--color-border-default);

            .ant-input {
                background-color: var(--color-bg-neutral-default);
                color: var(--color-text-default);

                &::placeholder {
                    color: var(--color-text-disabled);
                }
            }
        }
    }

    .error-description {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .description-tr,
        .description-en {
            display: flex;
            flex-direction: column;
            gap: 8px;

            strong {
                font-size: 14px;
                color: var(--color-text-strong-default);
            }

            p {
                margin: 0;
                font-size: 14px;
                line-height: 1.5;
                color: var(--color-text-default);
            }
        }

        .meta-link-alert {
            margin-top: 16px;

            :deep(a) {
                color: var(--color-primary-default);
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    :deep(.ant-collapse) {
        background-color: var(--color-bg-neutral-default);
        border: 1px solid var(--color-border-default);
        border-radius: 4px;
    }

    :deep(.ant-collapse-header) {
        font-size: 14px;
        color: var(--color-text-strong-default) !important;
    }

    :deep(.ant-collapse-content) {
        background-color: var(--color-bg-neutral-low-default);
    }
}
</style>
